<template>
    <div class="creatorEditWrapper">
        <div class="header">
            <h3>欢迎来到创作中心，打造名师IP，传播优质资源！</h3>
        </div>
        <el-card class="content">
            <el-form ref="editForm" :model="subForm" :rules="rules" label-width="100px" class="editForm">
                <el-form-item label="标题：" prop="title">
                    <el-input v-model="subForm.title"/>
                </el-form-item>
                <el-form-item label="封面：" prop="rscImage" class="cover">
                    <div class="upload-main">
                        <div class="upload-left cover-upload">
                            <label for="coverLoader" class="coverLoader">
                                <img v-if="subForm.rscImage && coverType === 1" :src="subForm.rscImage"/>
                                <input type="file" id="coverLoader" @change.self="onUploadCover($event)"/>
                            </label>
                            <p class="cover-tip"><i :class="{'active' : coverType === 1}"></i>自定义上传封面</p>
                        </div>
                        <div class="upload-right cover-upload">
                            <a href="javascript:void(0)" class="coverImgList" @click="defaultCoverVisible = true">
                                <img v-if="subForm.rscImage && coverType === 2" :src="subForm.rscImage"/>
                                <img v-else :src="tmpCover"/>
                            </a>
                            <p class="cover-tip"><i :class="{'active' : coverType === 2}"></i>选择默认封面</p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="简介：" prop="rscDesc" class="product">
                    <el-input type="textarea" v-model="subForm.rscDesc"/>
                </el-form-item>
                <el-form-item label="知识点：" prop="points" class="knowledge">
                    <div style="width:80px"></div>
                    <el-select
                            v-model="subForm.points"
                            value-key="id"
                            prefix-icon="el-icon-search"
                            multiple
                            filterable
                            remote
                            @change="changeSelect"
                            placeholder="请输入知识点关键词"
                            :remote-method="remoteMethod"
                            :loading="loading"
                    >
                        <el-option
                                v-for="(item,index) in knowledgeList"
                                :key="index"
                                :label="item.pointName"
                                :value="item"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="标签：" prop="labels" class="tag">
                    <span style="float: left">年级：</span>
                    <el-select v-model="subForm.gradeID" placeholder="请选择" @change="changeGrade">
                        <el-option
                                v-for="item in gradeInfo"
                                :key="item.gradeID"
                                :label="item.gradeName"
                                :value="item.gradeID">
                        </el-option>
                    </el-select>
                    <span style="float: left">科目：</span>
                    <el-select v-model="subForm.subjectID" placeholder="请选择" @change="changeSubject">
                        <el-option
                                v-for="item in subjectInfo"
                                :key="item.subjectID"
                                :label="item.subName"
                                :value="item.subjectID">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关联资源：" class="relate_resoure">
                    <div class="correlation">
                        <i class="el-icon-warning"></i>
                        <el-tooltip
                                class="item"
                                effect="dark"
                                content="同一系列的资源或资源的上下部分 可以相互关联，选择并关联后，资 源展示时将同时展示相关联的资源。"
                                placement="bottom-start"
                        >
                            <span>关联说明</span>
                        </el-tooltip>
                    </div>
                </el-form-item>
            </el-form>
            <div class="table_content">
                <div id="tab">
                    <!--Tab选项-->
                    <el-menu
                            :default-active="relationaActiveIndex"
                            class="el-menu-demo"
                            mode="horizontal"
                            @select="handleTabSelect"
                    >
                        <el-menu-item index="1">
                            视频上传
                        </el-menu-item>
                        <el-menu-item index="2">
                            音频上传
                        </el-menu-item>
                        <el-menu-item index="3">
                            文档上传
                        </el-menu-item>
                    </el-menu>
                    <!--Tab选项内容-->
                    <div class="tab-content">
                        <div
                                v-show="relationaActiveIndex === '1'"
                                class="content content1"
                        >
                            <el-table
                                    ref="multipleTable"
                                    :data="videoData"
                                    tooltip-effect="dark"
                                    style="width: 100%"
                                    @selection-change="handleSelectionChange($event, 2)"
                            >
                                <el-table-column
                                        type="selection"
                                        width="100"
                                        align="center"
                                />
                                <el-table-column
                                        label="资源标题"
                                        width="200"
                                        align="center"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.title }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="date"
                                        label="发布时间"
                                        width="200"
                                        align="center"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.uploadDate }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="record"
                                        label="是否有关联记录"
                                        show-overflow-tooltip
                                        align="center"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.isAssociat ? '是' : '否' }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div
                                v-show="relationaActiveIndex === '2'"
                                class="content content2"
                        >
                            <el-table
                                    ref="multipleTable"
                                    :data="audioData"
                                    tooltip-effect="dark"
                                    style="width: 100%"
                                    @selection-change="handleSelectionChange($event, 4)"
                            >
                                <el-table-column
                                        type="selection"
                                        width="100"
                                        align="center"
                                />
                                <el-table-column
                                        label="资源标题"
                                        width="200"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.title }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="date"
                                        label="发布时间"
                                        width="200"
                                        align="center"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.uploadDate }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="record"
                                        label="是否有关联记录"
                                        show-overflow-tooltip
                                        align="center"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.isAssociat ? '是' : '否' }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div
                                v-show="relationaActiveIndex === '3'"
                                class="content content3"
                        >
                            <el-table
                                    ref="multipleTable"
                                    :data="fileData"
                                    tooltip-effect="dark"
                                    style="width: 100%"
                                    @selection-change="handleSelectionChange($event, 1)"
                            >
                                <el-table-column
                                        type="selection"
                                        width="100"
                                        align="center"
                                />
                                <el-table-column
                                        label="资源标题"
                                        width="200"
                                        align="center"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.title }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="date"
                                        label="发布时间"
                                        width="200"
                                        align="center"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.uploadDate }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="record"
                                        label="是否有关联记录"
                                        show-overflow-tooltip
                                        align="center"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.isAssociat ? '是' : '否' }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <el-button
                    class="submit_btn"
                    type="primary"
                    @click="onSubmit"
            >提交审核
            </el-button>
        </el-card>
        <el-dialog title="选择默认封面" center :visible="defaultCoverVisible" @close="defaultCoverVisible = false"
                   width="880px" :close-on-click-modal="false">
            <div class="coverList">
                <img v-for="(item,index) in defaultCoverList" :key="index" :src="item"
                     @click="onClickDefaultCover($event,index)" :class="coverIndex === index ? 'active' :''"/>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onConfirmCover">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
  import { uploadImage } from '@/api/user';
  import {
    getPointInfoApi,
    getGradeInfo,
    getSubjectInfoApi,
    getMaterialInfoApi,
    getrscsApi,
    submitAudit,
    getResourceDetail
  } from '@/api/creator';
  import { $Cookies } from '@/utils';

  export default {
    name: 'CreatorEdit',
    data () {
      const validatePass = (rule, value, callback) => {
        if (!this.subForm.gradeID) {
          return callback(new Error('年级不能为空！'));
        }
        if (!this.subForm.subjectID) {
          return callback(new Error('科目不能为空！'));
        }
        callback();

      };
      return {
        subForm: {
          title: '',
          rscImage: '',
          rscDesc: '',
          points: [],
          subName: '',
          materialName: '',
          gradeID: '',
          subjectID: '',
          rscs: []
        },
        rules: {
          title: [
            { required: true, message: '请输入活动名称', trigger: 'blur' }
          ],
          rscImage: [
            { required: true, message: '请设置封面', trigger: 'change' },
          ],
          rscDesc: [
            { required: true, message: '请输入简介', trigger: 'blur' }
          ],
          points: [
            { required: true, message: '知识点不能为空', trigger: 'change' }
          ],
          labels: [
            { required: true, validator: validatePass, trigger: 'change' }
          ]
        },
        coverIndex: 0,
        coverType: 0,
        defaultCoverVisible: false,
        tmpCover: require('@/assets/images/creator/cover/1.png'),
        defaultCoverList: [
          require('@/assets/images/creator/cover/1.png'),
          require('@/assets/images/creator/cover/2.png'),
          require('@/assets/images/creator/cover/3.png'),
          require('@/assets/images/creator/cover/4.png'),
          require('@/assets/images/creator/cover/5.png'),
          require('@/assets/images/creator/cover/6.png'),
          require('@/assets/images/creator/cover/7.png'),
          require('@/assets/images/creator/cover/8.png'),
          require('@/assets/images/creator/cover/9.png'),
          require('@/assets/images/creator/cover/10.png'),
          require('@/assets/images/creator/cover/11.png'),
          require('@/assets/images/creator/cover/12.png'),
          require('@/assets/images/creator/cover/13.png')
        ],
        knowledgeList: [],
        loading: false,
        multipleSelection: [],
        ary: [],
        relationaActiveIndex: '1',
        videoData: [], //视频关联资源
        audioData: [],  //音频关联资源
        fileData: [],   //文档关联资源
        gradeInfo: [], // 年级
        subjectInfo: [],
        materialInfo: [],
        selectedOptions: [], //标签
      };
    },
    async mounted () {
      // 查询资源关联列表
      await this.getResourceDetail();
      await this.getGradeInfo();
      await this.getSubjectInfo();
      await this.getMaterialInfo();
      await this.getResourceData(2);
      await this.getResourceData(4);
      await this.getResourceData(1);
    },
    methods: {
      changeGrade (v) {
        this.subForm.gradeID = v;
      },
      changeSubject (v) {
        this.subForm.subjectID = v;
      },
      changeSelect () {
        this.$forceUpdate();
      },
      //上传封面
      onUploadCover (event) {
        const files = event.target.files[ 0 ];
        const formData = new FormData();
        formData.append('origin', 'g12e');
        formData.append('wmType', 0);
        formData.append('files', files);
        uploadImage(formData).then(data => {
          if (data.success) {
            const { sArray } = data.result;
            this.subForm.rscImage = sArray[ 0 ].url;
            this.coverType = 1;
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      onClickDefaultCover (e, index) {
        this.coverIndex = index;
      },
      onConfirmCover () {
        const path = window.location.origin;
        this.subForm.rscImage = path + this.defaultCoverList[ this.coverIndex ];
        this.coverType = 2;
        this.defaultCoverVisible = false;
      },
      getDefaultImgSelected (rscImage) {
        let imgOrigin = window.location.origin;
        if (!rscImage) {
          this.coverType = 0;
        } else {
          if (rscImage.indexOf(imgOrigin) > -1) {
            this.coverType = 2;
            let imgPath = rscImage.split(imgOrigin)[ 1 ];
            this.defaultCoverList.forEach((item, index) => {
              if (imgPath === item) {
                this.coverIndex = index;
              }
            });
          } else {
            this.coverType = 1;
            this.subForm.rscImage = rscImage;
          }
        }
      },
      remoteMethod (query) {
        if (query !== '') {
          this.loading = true;
          getPointInfoApi(query).then(data => {
            this.loading = false;
            if (data.success) {
              this.knowledgeList = data.result.list;
            }
          });
        } else {
          this.knowledgeList = [];
        }
      },
      // 关联资源切换
      handleTabSelect (key) {
        this.relationaActiveIndex = key;
      },
      getResourceData (type) {
        const uid = $Cookies.get('uid');
        const params = {
          userNo: uid,
          rscFileType: type
        };
        getrscsApi(params).then(data => {
          if (data.success) {
            switch (type) {
              case 2: // 视频资源
                this.videoData = data.result.list;
                if (this.videoData !== undefined && this.multipleSelection !== undefined) {
                  this.videoData.map(item => {
                    this.ary.map(val => {
                      if (item.rscID === val.rscID) {
                        this.$refs.multipleTable.toggleRowSelection(val);
                      }
                    });
                  });
                }
                break;
              case 4: // 音频资源
                this.audioData = data.result.list;
                break;
              case 1:
                this.fileData = data.result.list;
                if (this.fileData !== undefined && this.multipleSelection !== undefined) {
                  this.fileData.map(item => {
                    this.ary.map(val => {
                      if (item.rscID === val.rscID) {
                        this.$refs.multipleTable.toggleRowSelection(val);
                      }
                    });
                  });
                }
                break;
            }
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      // 选择关联资源
      handleSelectionChange (val, type) {
        this.ary = val;
        this.multipleSelection[ type ] = [];
        val.forEach(item => {
          this.multipleSelection[ type ].push({
            rscFileType: type,
            associateRscID: item.rscID
          });
        });
      },
      async getResourceDetail () {
        const uid = $Cookies.get('uid');
        const rscId = this.$route.query.id;
        const params = {
          rscID: rscId,
          userNo: uid
        };
        await getResourceDetail(params).then(data => {
          if (data.success) {
            const { title, rscImage, rscDesc, points, associates, gradeID, gradeName, subName, subjectID, materialID, materialName } = data.result;
            this.getDefaultImgSelected(rscImage);
            this.subForm = {
              title: title,
              rscImage: rscImage,
              rscDesc: rscDesc,
              gradeID: gradeID,
              gradeName: gradeName,
              subName: subName,
              subjectID: subjectID,
              materialName: materialName,
              materialID: materialID
            };
            for (let i = 0; i < associates.length; i++) {
              for (let j = 0; j < this.audioData.length; j++) {
                if (associates[ i ].rscID === this.audioData[ j ].rscID) {
                  this.$refs.multipleTable.toggleRowSelection(this.audioData[ j ].rscID, true);
                }
              }
            }
            this.ary = associates;
            //知识点
            points.forEach(item => {
              this.knowledgeList.push({
                id: item.id,
                pointName: item.pointName
              });
              this.subForm.points = this.knowledgeList;
            });
            //标签
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      //年级列表
      getGradeInfo () {
        getGradeInfo().then(data => {
          if (data.success) {
            this.gradeInfo = data.result;
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      //科目列表
      getSubjectInfo () {
        getSubjectInfoApi().then(data => {
          if (data.success) {
            this.subjectInfo = data.result;
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      //教材查询
      getMaterialInfo () {
        getMaterialInfoApi().then(data => {
          if (data.success) {
            this.materialInfo = data.result;
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      },
      // 提交审核
      onSubmit () {
        this.$refs.editForm.validate(valid => {
          if (!valid) {
            return false;
          }

          const rscID = this.$route.query.id;
          const uid = $Cookies.get('uid');
          if (!rscID) {
            this.$message.error('请确认rscID正确性！');
            return false;
          }
          const form = {
            userNo: Number(uid),
            rscID,
            title: this.subForm.title,
            rscImage: this.subForm.rscImage,
            rscDesc: this.subForm.rscDesc,
            gradeID: this.subForm.gradeID ? this.subForm.gradeID : '',
            subjectID: this.subForm.subjectID ? this.subForm.subjectID : '',
            materialID: this.subForm.materialID ? this.subForm.materialID : '',
            rscs: [],
            points: []
          };
          this.subForm.points.forEach(item => {
            form.points.push(item.id);
          });
          if (this.multipleSelection.length) {
            this.multipleSelection.forEach(item => {
              if (item.length) {
                item.forEach(child => {
                  form.rscs.push(child);
                });
              }
            });
          }
          submitAudit(form).then(data => {
            if (data.success) {
              this.$message({
                type: 'success',
                message: data.result.result,
                duration: 1000,
                onClose: () => {
                  this.$router.push('/creator/resourceManage?status=2');
                }
              });
            } else {
              this.$message.error(data.errorMsg);
            }
          });
        });
      }
    }
  };
</script>
<style lang="scss">
</style>
<style lang="scss">
    .tag .el-form-item__content {
        .el-select {
            float: left;
            width: 100px;
            margin-right: 25px;
        }
    }
</style>
